const defaultColors = ['#ffffff', '#a9a9a9', '#808080', '#696969'];

export default function ColorChartThumbnail({ data, colors, minrows, mincols, size, norepeat, settings }) {
  // Limit data to first 100 rows and 100 columns
  const limitedData = data ? data.slice(0, 100).map(row => row.slice(0, 100)) : null;
  
  const rows = limitedData ? limitedData.length : 0;
  const cols = limitedData && limitedData[0] ? limitedData[0].length : 0;
  const repeatrows = !norepeat && rows && minrows && minrows > rows ? Math.floor(minrows / rows) : 1;
  const repeatcols = !norepeat && cols && mincols && mincols > cols ? Math.floor(mincols / cols) : 1;

  function getCellColor(col) {
    // Handle no-stitch cells (only null values, not 0)
    if (col === null) {
      return settings?.noStitchColor || '#e0e0e0'; // Use configurable color or default
    }
    
    // Handle valid color indices (including 0)
    if (colors && col !== null && col < colors.length) {
      return colors[col];
    } else if (defaultColors && col !== null && col < defaultColors.length) {
      return defaultColors[col];
    } else {
      return 'black'; // Fallback for invalid indices
    }
  }

  // Helper function to get cell data - always using top-down and left-to-right
  const getCellData = (visualRow, visualCol) => {
    if (!limitedData || visualRow >= rows || visualCol >= cols) return null;
    
    // Since we always use top-down and left-to-right, visual coordinates = data coordinates
    const cellValue = limitedData[visualRow]?.[visualCol];
    return cellValue !== undefined ? cellValue : null;
  };

  const cellsize = size && cols < 40 ? 4 * size : 4;
  const cellstyle = {
    height: cellsize,
    width: cellsize,
    borderWidth: 0,
    borderColor: 'lightgrey',
    borderStyle: 'solid'
  };

  return (
    limitedData && (
      <div style={styles.chartContainer}>
        <div style={styles.horizontal}>
          <div style={styles.chart}>
            {Array(repeatrows)
              .fill({})
              .map((_, x) => {
                return Array(rows).fill({}).map((_, visualRow) => (
                  <div key={`${x}_${visualRow}`} style={styles.row}>
                    {Array(repeatcols)
                      .fill({})
                      .map((_, y) => {
                        return Array(cols).fill({}).map((_, visualCol) => {
                          const cellData = getCellData(visualRow, visualCol);
                          return (
                            <div 
                              key={`${x}_${visualRow}_${y}_${visualCol}`} 
                              style={{ ...cellstyle, backgroundColor: getCellColor(cellData) }} 
                            />
                          );
                        });
                      })}
                  </div>
                ));
              })}
          </div>
        </div>
      </div>
    )
  );
}

const styles = {
  horizontal: {
    display: 'flex',
    flexDirection: 'row'
  },
  chartContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  chart: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-start'
  }
};
